import ApiService from './ApiService';
import AuthService from './AuthService';

class InfoService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._attributesCategoryUrl = '/info/attributes/category';
        this._attributesCategoriesUrl = '/info/attributes/categories';
        this._attributesWithCategoriesUrl = '/info/attributes-categories';
        this._attributesEnumAttributesUrl = '/info/attributes/enum-attributes';
        this._categoryMainUrl = '/info/category/main';
        this._categorySubUrl = '/info/category/sub';
        this._categoryManufacturersUrl = '/info/category/manufacturers';
        this._categoryPacksUrl = '/info/category/packs';
        this._currenciesUrl = '/info/general/currencies';
        this._creditGuarantiesUrl = '/info/order/guaranties';
        this._orderStatusesUrl = '/info/order/statuses';
        this._mainInfoUrl = '/info/main-info';
        this._textPageUrl = '/info/text-page';
        this._currenciesUrl = '/info/general/currencies';
        this._paymentWaysUrl = '/info/general/payment-ways'
        this._sellersUrl = '/info/general/sellers'
        this._quantityUnitsUrl = '/info/general/quantity-units';

    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getAttributesCategory(id) {
        return this.postResource(this._attributesCategoryUrl, {categoryID: id}, this.getLangHeader())
    }

    getAttributesCategories() {
        return this.postResource(this._attributesCategoriesUrl, {}, this.getBaseHeaders());
    }

    getAttributesWithCategories() {
        return this.postResource(this._attributesWithCategoriesUrl, {}, this.getBaseHeaders());

    }

    getAttributesEnumAttributes() {
        return this.postResource(this._attributesEnumAttributesUrl, {}, this.getBaseHeaders());
    }

    getMainCategories() {
        return this.postResource(this._categoryMainUrl, {}, this.getLangHeader());
    }

    getSubCategories(parentId) {
        return this.postResource(this._categorySubUrl, {categoryID: parentId}, this.getLangHeader())
    }

    getCategoryManufacturers(categoryId) {
        return this.postResource(this._categoryManufacturersUrl, {categoryID: categoryId}, this.getLangHeader())
    }

    getCategoryPacks(parentId) {
        return this.postResource(this._categoryPacksUrl, {categoryID: parentId}, this.getLangHeader())
    }

    getCurrencies() {
        return this.postResource(this._currenciesUrl, {}, this.getLangHeader());
    }

    getPaymentWays() {
        return this.postResource(this._paymentWaysUrl, {}, this.getLangHeader())
    }

    getOrderStatuses() {
        return this.postResource(this._orderStatusesUrl, {}, this.getLangHeader());
    }

    /*getTextPage(systemName) {
        return this.postResource(this._textPageUrl, {systemName}, this.getLangHeader());
    }

    getCreditGuaranties() {
        return this.getResource(this._creditGuarantiesUrl, {headers: this.getLangHeader()});
    }

    getMainInfo() {
        return this.postResource(this._mainInfoUrl, {}, this.getLangHeader());
    }*/

    getSellers() {
        return this.postResource(this._sellersUrl, {}, this.getLangHeader())
    }

    getQuantityUnits() {
        return this.postResource(this._quantityUnitsUrl, {}, this.getLangHeader())
    }
}

const Service = new InfoService(AuthService);

export default Service;
